import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { descuentosReglasApi } from '@/data/api/descuentosReglasApi';
const KEY = 'descuentos-reglas';
export function useReglasDescuento(tipo, activo) {
    return useQuery({
        queryKey: [KEY, tipo, activo],
        queryFn: () => descuentosReglasApi.listar(tipo, activo),
        staleTime: 60_000,
    });
}
export function useCrearReglaDescuento() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (v) => descuentosReglasApi.crear(v),
        onSuccess: () => qc.invalidateQueries({ queryKey: [KEY] }),
    });
}
export function useEditarReglaDescuento() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ id, values }) => descuentosReglasApi.editar(id, values),
        onSuccess: () => qc.invalidateQueries({ queryKey: [KEY] }),
    });
}
export function useDesactivarReglaDescuento() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (id) => descuentosReglasApi.desactivar(id),
        onSuccess: () => qc.invalidateQueries({ queryKey: [KEY] }),
    });
}
